module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("E")])]), _vm._v("lizabeth swallowed hard. She’d never considered how fried chicken or cold milk arrived at the Manning table. Drat, she’d have to scrub her glove. Not that Sally’s intended looked as if he didn’t wash. He smelled clean, like soap, leather and sunshine.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mercy, the man was brawny, wide at the shoulders with a massive neck, chest and powerful forearms. Not someone she’d care to cross. White creases edged his eyes in his tanned face, evidence of long periods spent in the sun. Those intense blue-gray eyes of his appeared to see right through her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She hoped she was wrong about that.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But all the rest…well, she couldn’t find anything to complain about. She’d expected another Reginald Parks and another reason to run. But something about Ted Logan kept her rooted to the spot, unable to look away.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Decency demanded she tell him she wasn’t his bride. But if she did, would he insist she take the next train back? She needed time to think. To take a look at the town and see if she could find employment here.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("She couldn’t forget the importance of that farm, the fulfillment of her brother’s dream. If only that didn’t mean she had ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("to marry the man, and all that entailed. She shivered. Well, she wasn’t foolish enough to give her heart to this man.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Through narrowed eyes, he looked her over. “I expected you to have brown hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She gulped. “You don’t like my hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The color of your hair doesn’t matter a whit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Glad to hear it.” She leaned toward him. “And so you know, I happen to like the color of yours. It’s lighter than I expected, but it’s tolerable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His lips twisted up at one corner, as if they tried to smile without his approval. “I can’t decide if I like a woman talking to me like that. Especially one I’m about to marry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Elizabeth’s stomach flipped at the mention of matrimony, a subject she intended to avoid. Her gaze traveled to a field of cows grazing not far from the tracks. “It’s better than talking to the cows, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With a large hand, he gently tilted her face to his. “Yep. And a far sight better view.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A woozy feeling slid over her. Without thinking, she grabbed hold of his arm for support. And found rock-hard muscle. Beneath her feet, the ground shifted. She hadn’t eaten in what seemed like forever. That had to be the reason for her vertigo.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He gave her a smirk and pulled away. “I’ll get the rest of your things.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Things? Oh, my luggage.” Once he discovered she had no trunk, he’d send her back. Without money for food or housing, how would she take care of Robby? Moisture beaded her upper lip. “I, ah, left the trunk unattended in Chicago, only for a minute.” With guilt at her lie niggling at her, she added, “When I returned, it was gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Everything you bought with the money I sent—is gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She nodded. Twice. “I’m sorry.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Didn’t you think to check it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Didn’t you ever make a mistake?” she fired back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure have,” he said, arms folded across his chest, “but I’ve never lost all my clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She grabbed a fistful of skirt. “Well, neither have I.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He sighed. “We’ll have to stop at the mercantile.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If only she’d had time to gather her clothes scattered across the lawn. “I’ll make do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Waving a hand at her dress, he arched a brow. “With only that frippery to wear day and night?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That frippery is silk shantung, I’ll have you know.” She poked the rumpled lapel of his suit. “Do you think you’re qualified to judge "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" fashion sense?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He grinned, a most appealing smile. Or would be if he wasn’t the most exasperating man she’d ever met.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s not your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fashion")]), _vm._v(" sense I’m questioning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Determined to stare him down, she held his gaze. Neither of them gave ground as travelers swept past them, tossing an occasional curious glance their way. “I’m smarter than you think.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Smart enough to sew a new dress?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I can sew.” She ducked her head. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Did embroidering pillow slips count?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We’ll purchase fabric, whatever you need later.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Perhaps the store could use a clerk. The possibility eased the tension in her limbs. Instead of arguing with him, she’d better keep her head if she hoped to escape this mess. But without food she could barely keep on her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ted plopped his straw hat in place then took the satchel from her. “Better get moving. The preacher’s waiting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His words cut off her air supply as effectively as if he’d wrapped those large hands of his around her windpipe and squeezed. “So soon?”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Did you expect to be courted first?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She’d expected to remain single but wouldn’t say that. “Well…no.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Behind them, the locomotive emitted a whistle, the call of “All aboard!” Wheels turned, picking up speed as the train chugged out of the station, taking with it her means of escape.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Elizabeth’s eyes roamed what appeared to be the town’s main street. Maybe she could find work here, though not a solitary establishment looked prosperous. She gnawed her lip and faced the truth. Unless a shop needed a clerk who could recite the multiplication tables while pouring tea, she had slim chance of finding employment.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hysteria bubbled up inside her. She clamped her mouth shut, fighting the compulsion to laugh. Breathe in. Breathe out. Breathe in. Thankfully, the giddy sensation passed, replaced with the heavy weight of responsibility. Robby was depending on her, not a laughing matter.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ted took hold of her elbow and ushered her along the platform. “We both know this marriage is one of convenience, a business arrangement.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Exactly what she wanted to hear, wasn’t it? Then why did his words sting like a slap? Well, business arrangement or not, how could she wed a stranger? Elizabeth dug in her heels and yanked out of his grasp. “I…I can’t. I can’t marry you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ted turned to her, searching her face. His expression softened. He took her hand in his and ran his thumb along the top. Her stomach dipped. His gentle touch gave her a measure of comfort…and far too much awareness of the man.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“This isn’t easy for either of us,” he said, his eyes filling with tenderness. “But I want you to know, I’ll be kind to you. Work hard to provide for you. I don’t have much, but all I have is yours.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Elizabeth didn’t want to marry, but what choice did she have? She didn’t know a soul in this town. Didn’t have a penny ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("to her name. Didn’t have a single idea what to do. That made her—a desperate woman.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("A desperate woman with a proposal on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A proposal that would solve all her problems.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Except this proposal was permanent—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" offered to another woman. What would Ted say once he knew her true identity?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“My farm isn’t much,” he continued, his voice steady, calm. “But with God providing the sunshine and rain, the earth gives back what I put into it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Such a simple yet profound statement. This man gave instead of took. He relied on hard labor, not luck. Ted Logan had planted his feet, appeared as solid as the earth he worked, the exact opposite of her father.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I have cows, pigs, chickens, horses.” He paused, then chuckled. “A dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Elizabeth’s heart skittered. “What does your dog look like?” She held her breath, every muscle tense as she waited for his answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Black and white. Shaggy.” Ted shrugged. “Lovable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Goose bumps rose on her arms. The exact description of the puppy Papa had given Robby, then taken away.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Martha always said there was no such thing as coincidence, not for a praying believer. Could Ted Logan be God’s answer for Robby? Without a doubt her brother would adore this hulk of a man. Yes, Robby’s dream stood before her with the promise of a wedding band.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ted held out an arm. “Are you ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A business arrangement he’d said. Maybe if she dealt with the marriage that way, she could go through with the wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For Robby’s sake she would.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She slipped her hand into the crook of his waiting arm. They strolled along the street. The occasional passerby gave them a speculative look, but by now most people had left the station.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Ted stopped at a weathered wagon with nary a speck of gild, nor springs or leather on the wooden seat to soften bumps in the road. Two enormous dark brown horses wearing blinders swung their heads to get a better look at her, their harnesses jingling a greeting. Her carriage waited. The matched pair were built for hard work not pretension, like Ted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s King and his missus, Queen. They’re Percherons,” Ted said, a hint of pride in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Elizabeth didn’t know much about breeds to work the farm, but Ted obviously cared for his animals, another point in his favor. She ran her hand along a velvety nose. “They’re beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And mighty curious about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Clearly she’d traded a fancy carriage for a rickety wagon, but a far more suitable groom. Her fingers toyed with the lily of the valley pinned to her dress. Could she go through with it? Could she marry a stranger?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before she knew what happened, Ted handed her up onto the seat with ease, as if she weighed no more than dandelion fluff, then swung up beside her. Elizabeth shifted her skirts to give him room, while the memory of those large hands, warm and solid through the fabric of her dress, spun through her, landing in her stomach with a disturbing flutter.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She glanced at Ted’s square profile, at this strong, no-nonsense man. The eyes he turned on her spoke of kindness. Even excluding Reginald Parks, she could do far worse. No doubt Ted Logan was a good man. He’d be kind to Robby. To her. That is if he didn’t retract his offer of marriage once she revealed her true identity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He clicked to the horses. “I left my children at the neighbor’s. I’ll pick them up tomorrow after breakfast.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Elizabeth swayed on the seat. “Children?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Don’t tell me you’ve forgotten Anna and Henry?”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Sally hadn’t mentioned children. “I’m just…tired.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("How old were they? Since Mama died, Robby’s care had been left to Martha. Sure, Elizabeth had read to her brother, taught him to tie his laces, but she had no experience caring for children.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What did she know about husbands for that matter?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And the tomorrow-morning part—did he intend a wedding night?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Well, if he had that expectation, she’d call on her touchy stomach. No bridegroom would want a nauseous bride.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Though if she didn’t get something to eat—and soon—there wouldn’t be a wedding. For surely the bride would be fainting on the groom.")])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page27"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1402baa4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/substitutebridethe_ch02.vue
// module id = 81
// module chunks = 0